// Independent page composition for Software Quality Assurance.
const { h, PageFrame, section, split, context, deliverables, scenario, answer, scope, diagram } = require('../pageParts');
module.exports = function QualityAssurancePage({ service }) {
  return h(PageFrame, { service, tone: 'wide', hero: diagram(service, 'board') },
    section('Start with the decision you need to make', context(service), { className: 'ai-narrow-section' }),
    section('A useful engagement produces evidence', split(deliverables(service, 'rows'), scenario(service)), { theme: 'ai-wash' }),
    section(null, split(answer(service), scope()))
  );
};
